/**
 * Supported languages in virtual-web. French and German are not supported and are mapped to English.
 */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'it'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Maps a language code from session/user/backend to a supported language.
 * French (fr) and German (de) are normalized to English (en).
 */
export function normalizeSupportedLanguage(lang: string | null | undefined): SupportedLanguage {
  if (lang == null || String(lang).trim() === '') return 'en';
  const code = String(lang).toLowerCase().trim();
  if (code === 'fr' || code === 'de') return 'en';
  if (SUPPORTED_LANGUAGES.includes(code as SupportedLanguage)) return code as SupportedLanguage;
  return 'en';
}
